(() => {
  if (window.__F24VariantStockLoaded) return;
  window.__F24VariantStockLoaded = true;

  const copyStatus = (source, destination) => {
    if (!source || !destination) return;
    destination.innerHTML = source.innerHTML;
    destination.className = source.className;
    ['f24StockState', 'f24StockShort', 'f24SelectedVariantId', 'f24SelectedVariantSku'].forEach((key) => {
      if (source.dataset[key] !== undefined) destination.dataset[key] = source.dataset[key];
    });
  };

  const syncFromRenderedSection = ({ sectionId, html } = {}) => {
    if (!sectionId || !html) return;
    const destinationInfo = document.querySelector(`product-info[data-section="${CSS.escape(sectionId)}"]`) || document.getElementById(`MainProduct-${sectionId}`);
    if (!destinationInfo) return;
    const destinationSectionId = destinationInfo.dataset.section || sectionId;
    const sourceStatus = html.getElementById(`F24StockStatus-${sectionId}`);
    const destinationStatus = destinationInfo.querySelector(`#F24StockStatus-${CSS.escape(destinationSectionId)}`);
    copyStatus(sourceStatus, destinationStatus);
    const sourceOrderStock = html.getElementById(`F24OrderStock-${sectionId}`);
    const destinationOrderStock = destinationInfo.querySelector(`#F24OrderStock-${CSS.escape(destinationSectionId)}`);
    if (sourceOrderStock && destinationOrderStock) destinationOrderStock.value = sourceOrderStock.value;
    destinationInfo.dispatchEvent(new CustomEvent('f24:variant-stock-updated', { bubbles: true }));
  };

  const connect = (attempt = 0) => {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.variantChange) {
      subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => syncFromRenderedSection(data));
      return;
    }
    if (attempt < 40) window.setTimeout(() => connect(attempt + 1), 100);
  };

  connect();
})();
